import { createContext } from "react";

export const CouponContext = createContext<{
  isCouponModalOpen: boolean;
  setCouponModalOpen: (val: boolean) => void;
}>({
  isCouponModalOpen: false,
  setCouponModalOpen: () => {},
});
